import { useQuery } from '@tanstack/react-query'
import { apiJson } from '@/api/client'

export const queueDepthsQueryKey = ['alerts', 'queue-depths'] as const

interface QueueDepth {
  queue_id: string
  queue_name: string
  open_count: number
  in_review_count: number
  sla_breached_count: number
}

interface Response {
  queues: QueueDepth[]
}

/**
 * AF-126 — live counts per fraud queue, used by the sidebar nav.
 * Refetches every 60s and on WebSocket cache invalidation.
 */
export function useQueueDepths() {
  return useQuery({
    queryKey: queueDepthsQueryKey,
    queryFn: () => apiJson<Response>('/queues/depths'),
    staleTime: 30_000,
    refetchInterval: 60_000,
  })
}
